module.exports = __webpack_public_path__ + "static/img/s99.c9a2ac43.png";